import { getAccessToken } from "../store/api/baseApi";

class NotificationService {
  constructor(onNotification) {
    this.onNotification = onNotification;
    this.eventSource = null;
  }

  start() {
    const token = getAccessToken();
    if (!token) return;

    const BASE_URL = (
      process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api"
    ).replace(/\/api\/?$/, "");

    // ✅ Route correcte : /api/notifications/stream
    const url = `${BASE_URL}/api/notifications/stream?token=${token}`;

    this.eventSource = new EventSource(url);

    this.eventSource.onmessage = (event) => {
      try {
        const notification = JSON.parse(event.data);
        this.onNotification(notification);
      } catch {
        // ignorer les heartbeats
      }
    };

    this.eventSource.onerror = () => {
      this.close();
    };
  }

  close() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }
}

export default NotificationService;